export type ExpirationOption = '1h' | '24h' | '7d' | '30d' | 'never';

export const EXPIRATION_LABELS: Record<ExpirationOption, string> = {
  '1h': '1 Hour',
  '24h': '24 Hours',
  '7d': '7 Days',
  '30d': '30 Days',
  'never': 'Never',
};

export const EXPIRATION_MS: Record<ExpirationOption, number> = {
  '1h': 60 * 60 * 1000,
  '24h': 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
  '30d': 30 * 24 * 60 * 60 * 1000,
  'never': 0,
};
